import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const getQuestionDetails = createAsyncThunk('getQuestionDetails', async ({ id, navigate }) => {
    try {
        const questionId = id?.question_id || id?.id || id;
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `question/${questionId}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie("user_token")
            }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const questionDetailsSlice = createSlice({
    name: 'questionDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(getQuestionDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
    }
})

export default questionDetailsSlice.reducer;
